import styled from '@emotion/styled';
import { List as ListIcon, Settings as SettingsIcon } from '@mui/icons-material';
import { MicIcon } from '~/modules/Elements/MicIcon';
import { PhoneTabs } from '~/routes/RemoteMic/RemoteMic';

interface Props {
  active: PhoneTabs;
  setActiveTab: (active: PhoneTabs) => void;
}

export default function BottomBar({ active, setActiveTab }: Props) {
  return (
    <BarContainer>
      <ItemContainer
        type="button"
        active={active === 'microphone'}
        onClick={() => setActiveTab('microphone')}
        data-test="menu-microphone">
        <ItemIcon>
          <MicIcon />
        </ItemIcon>
        <ItemTitle>Mic</ItemTitle>
      </ItemContainer>

      <ItemContainer
        type="button"
        active={active === 'song-list'}
        onClick={() => setActiveTab('song-list')}
        data-test="menu-song-list">
        <ItemIcon>
          <ListIcon />
        </ItemIcon>
        <ItemTitle>Songs</ItemTitle>
      </ItemContainer>

      <ItemContainer
        type="button"
        active={active === 'settings'}
        onClick={() => setActiveTab('settings')}
        data-test="menu-settings">
        <ItemIcon>
          <SettingsIcon />
        </ItemIcon>
        <ItemTitle>Settings</ItemTitle>
      </ItemContainer>
    </BarContainer>
  );
}

const BarContainer = styled.nav`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  width: 100%;
  min-height: 68px;
  padding: 8px;
  gap: 8px;
  border-top: 1px solid var(--walky-border);
  background: color-mix(in srgb, var(--walky-canvas) 82%, transparent);
  backdrop-filter: blur(12px);
`;

const ItemContainer = styled.button<{ active?: boolean }>`
  min-width: 0;
  min-height: 50px;
  cursor: pointer;
  border: 1px solid ${(props) => (props.active ? 'rgba(244, 90, 10, 0.55)' : 'var(--walky-border)')};
  border-radius: 10px;
  background: ${(props) =>
    props.active ? 'linear-gradient(135deg, var(--walky-orange), #ff7a1a)' : 'var(--walky-surface-raised)'};
  color: ${(props) => (props.active ? '#ffffff' : 'var(--walky-ink)')};
  box-shadow: ${(props) => (props.active ? '0 10px 22px rgba(244, 90, 10, 0.22)' : 'var(--walky-shadow)')};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font: inherit;
  transition:
    background 160ms ease,
    border-color 160ms ease,
    color 160ms ease,
    transform 160ms ease;

  &:active {
    transform: translateY(1px);
  }

  &:focus-visible {
    outline: 2px solid var(--walky-orange);
    outline-offset: 2px;
  }
`;

const ItemIcon = styled.div`
  display: inline-flex;

  svg {
    width: 22px;
    height: 22px;
  }
`;

const ItemTitle = styled.div`
  font-size: 12px;
  font-weight: 800;
  line-height: 1;
`;
